import React from "react";
import useSWR from "swr";
import { CategoryApiUrls } from "../../../../../Api/Auth/ApiUrls";
import Selector from "../../../../../Components/Common/Selector";
import Input from "../../../../../Components/Common/Input";
import ImageSelector from "../../../../../Components/Common/ImageSelector";

const PackageForm = ({
  onChange,
  handleSubmit,
  errors,
  formData,
  setModalOpen,
}) => {
  const { isLoading, data } = useSWR(CategoryApiUrls.list);
  // Extract hours and minutes from formData.time (if exists)
  const [hours, minutes] = formData.time?.split(":") || ["", ""];

  // Handle hours and minutes change
  const handleTimeChange = (name, value) => {
    // Ensure valid input (only numbers)
    if (!/^\d*$/.test(value)) return;

    // Restrict minutes to 0-59
    if (name === "minutes" && (value > 59 || value.length > 2)) return;

    // Update formData.time as "HH:MM"
    const newTime =
      name === "hours"
        ? `${value}:${minutes || "00"}`
        : `${hours || "0"}:${value}`;
    onChange("time", newTime);
  };
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Title"
        type="text"
        name="title"
        value={formData.title}
        onChange={onChange}
        placeholder="Enter package title"
        error={errors.title}
        required
      />
      <Selector
        name="category"
        label="Category"
        value={formData?.category}
        options={data?.data?.map((item) => ({
          label: item.title,
          value: item._id,
        }))}
        isClearable={false}
        onChange={onChange}
        error={errors?.category}
        isLoading={isLoading}
        required
      />
      <Input
        label="Price"
        type="number"
        name="price"
        value={formData.price}
        onChange={onChange}
        placeholder="Enter material price"
        error={errors.price}
        required
      />
      <div className="flex gap-2">
        <Input
          label="Hours"
          type="number"
          name="hours"
          value={hours}
          onChange={handleTimeChange}
          placeholder="HH"
          min={0}
          error={errors.time}
          required
        />
        <Input
          label="Minutes"
          type="number"
          name="minutes"
          value={minutes}
          onChange={handleTimeChange}
          placeholder="MM"
          min={0}
          max={59}
          error={errors.time}
          required
        />
      </div>
      <ImageSelector
        label="Upload Image"
        name="image"
        setModalOpen={setModalOpen}
        onChange={onChange}
        value={formData.image}
        placeholder="Click to select an image"
      />
      <Input
        label="Action Button"
        type="text"
        name="actionButton"
        value={formData.actionButton}
        onChange={onChange}
        placeholder="Enter action button text"
        error={errors.actionButton}
      />
    </form>
  );
};

export default PackageForm;
